export const SOW_ORDER_STATUSES = [
     { id: 'Open', name: 'Open' },
     { id: 'Close', name: 'Close' },
];

export const SOW_ORDER_OVERVIEW_PURCHASE_ORG_COLUMNS = [
     {
          key: 'name',
          label: 'Item',
          _style: { minWidth: '310px', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'price',
          label: 'Cost',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'quantity',
          label: 'Quantity',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'discount',
          label: 'Discount',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
];

export const SOW_ORDER_OVERVIEW_COLUMNS = [
     {
          key: 'name',
          label: 'Item',
          _style: { minWidth: '310px', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'price',
          label: 'Cost',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'quantity',
          label: 'Quantity',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'discount',
          label: 'Discount',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'released',
          label: 'Released',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'invoiced',
          label: 'Invoiced',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'eventAssigned',
          label: 'Event Assigned',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
     {
          key: 'shipmentAssigned',
          label: 'Shipment Assigned',
          _style: { minWidth: '95px', textAlign: 'center', fontWeight: '700' },
          filter: false,
     },
];

export const SOW_ORDER_VIEW_COLUMNS = [
     {
          key: 'name',
          label: 'Item',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'quantity',
          label: 'Quantity Invoiced',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'price',
          label: 'Cost',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'discount',
          label: 'Discount',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
];

export const SOW_ORDER_VIEW_ITEM_COLUMNS = [
     {
          key: 'creditId',
          label: 'Credit ID',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'creditStatus',
          label: 'Credit Seat Status',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'seatCode',
          label: 'Seat ID',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'eventSelfId',
          label: 'Event ID',
          _style: { minWidth: '95px' },
          _props: {},
     },
     {
          key: 'seatStatus',
          label: 'Seat Status',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'email',
          label: 'Email',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'courseStatus',
          label: 'Progress Status',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'shipmentId',
          label: 'Shipment ID',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
];

export const EDIT_SOW_ORDER_COLUMNS = [
     {
          key: 'name',
          label: 'Item',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'price',
          label: 'Cost',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'quantity',
          label: 'Quantity',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'discount',
          label: 'Discount',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'released',
          label: 'Released',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'invoiced',
          label: 'Invoiced',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'add',
          label: 'Add Quantity',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'remove',
          label: 'Remove Quantity',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'newQuantity',
          label: 'New Total Quantity',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'newTotal',
          label: 'New Total',
          _style: { minWidth: '95px' },
          filter: false,
     },
];

export const ADD_ITEMS_SUMMARY_COLUMNS = [
     {
          key: 'name',
          label: 'Item',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'eventName',
          label: 'Event',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'quantity',
          label: 'Quantity',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'price',
          label: 'Price',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'discount',
          label: 'Discount',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
];

export const RELEASE_SUMMARY_COLUMNS = [
     {
          key: 'name',
          label: 'Item',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'selectedQty',
          label: 'Quantity To Be Released',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'price',
          label: 'Cost',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'discount',
          label: 'Discount',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
];

export const RELEASE_DETAIL_COLUMNS = [
     {
          key: 'name',
          label: 'Item',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'quantity',
          label: 'Quantity Released',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'cost',
          label: 'Cost',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'discount',
          label: 'Discount',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
];
export const RELEASE_SEATS_DETAIL_COLUMNS = [
     {
          key: 'creditId',
          label: 'Credit ID',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'creditStatus',
          label: 'Credit Seat Status',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },

     {
          key: 'code',
          label: 'Seat ID',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'eventSelfId',
          label: 'Event ID',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'status',
          label: 'Seat Status',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'firstName',
          label: 'First Name',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'lastName',
          label: 'Last Name',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'email',
          label: 'Email',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'progressStatus',
          label: 'Progress Status',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'shipmentId',
          label: 'Shipment ID',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
];

export const INVOICED_SUMMARY_COLUMNS = [
     {
          key: 'name',
          label: 'Item',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'invoicedSelectedQty',
          label: 'Quantity To Be Invoiced',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'price',
          label: 'Cost',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'discount',
          label: 'Discount',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
     {
          key: 'total',
          label: 'Total',
          _style: { minWidth: '95px' },
          _props: {},
          filter: false,
     },
];
export const SOW_ORDER_TRAINING_EVENT_COLUMNS = [
     {
          key: 'selfId',
          label: 'Event Id',
          _style: { minWidth: '95px' },
     },
     {
          key: 'name',
          label: 'Name',
          _style: { minWidth: '95px' },
     },
     {
          key: 'startAt',
          label: 'Start At',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'createdAt',
          label: 'Creation Date',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'updatedAt',
          label: 'Last Modified',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'maxSeats',
          label: 'Max Seats',
          _style: { width: '125px' },
          filter: false,
     },
     {
          key: 'manageEventAction',
          label: '',
          _style: { minWidth: '95px' },
          filter: false,
          sorter: false,
     },
     {
          key: 'addCreditsAction',
          label: '',
          _style: { minWidth: '95px' },
          filter: false,
          sorter: false,
     },
];

export const SOW_SHIPMENT_SEATS_COLUMNS = [
     {
          key: 'code',
          label: 'Seat ID',
          _style: { minWidth: '95px' },
     },

     {
          key: 'releaseId',
          label: 'Released',
          _style: { minWidth: '95px' },
          filter: false,
     },
     {
          key: 'orderInvoiceId',
          label: 'Invoiced',
          _style: { minWidth: '95px' },
          filter: false,
     },
];

export const TABS_SOW_ORDERS = {
     OVERVIEW: 'overview',
     RELEASE_SEATS_CREDIT: 'released-seats-credits',
     INVOICED_ORDERS: 'invoiced-orders',
     TRAINING_EVENTS: 'training-events',
     SHIPMENTS: 'shipments',
     ATTACHMENT: 'attachments',
};

export const TABS_SOW_ORDERS_ORG = {
     OVERVIEW: 'org-overview',
     RELEASE_SEATS_CREDIT: 'org-released-seats-credits',
     INVOICED_ORDERS: 'org-invoiced-orders',
     TRAINING_EVENTS: 'org-training-events',
     SHIPMENTS: 'org-shipments',
     ATTACHMENT: 'org-attachments',
};

export const SOW_INVOICED_ORDER_STATUS = {
     DRAFT: 'draft',
     UNPAID: 'unpaid',
     PAID: 'paid',
};

export const LIST_SOW_BDR = [
     { id: 'Kevin Crowley', name: 'Kevin Crowley' },
     { id: 'Mariam Gregorian', name: 'Mariam Gregorian' },
     { id: 'Other', name: 'Other' },
];
